export default "__VITE_ASSET__BHiWsHS4__"